import cx from 'classnames';
import React from 'react';
import styled from 'styled-components';

import colors from 'utils/colors';
import device from 'utils/device';

export type ComponentProps = {
  text: string;
  link: string;
  className?: string;
  onClick?: () => void;
};

const Anchor = styled.a`
  color: ${colors.white};
  border: none;
  padding: 14px 0;
  cursor: pointer;
  transition: all 0.1s ease-in-out;
  background: transparent;
  display: flex;
  justify-content: flex-start;
  outline-color: ${colors.orange};
  text-decoration: none;
  flex-basis: 100%;

  :hover,
  :focus {
    color: ${colors.orange};
  }

  :first-child {
    padding-top: 0;
  }

  :last-child {
    padding-bottom: 0;
  }

  @media ${device.isTablet}, ${device.isDesktop} {
    flex: 0 50%;

    :first-child {
      padding-top: 14px;
    }

    :last-child {
      padding-bottom: 14px;
    }
  }
`;

const Text = styled.span`
  line-height: 1.4em;
`;

const Link: React.FC<ComponentProps> = ({ text, link, className = '', onClick = () => {} }) => {
  return (
    <Anchor href={link} onClick={onClick} className={cx({ [className]: !!className })}>
      <Text>{text}</Text>
    </Anchor>
  );
};

export default Link;
